var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkCircleChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.502,
    height: 18.502,
    viewBox: "0 0 18.502 18.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M12.626,3.375a9.251,9.251,0,1,0,9.251,9.251A9.249,9.249,0,0,0,12.626,3.375Zm4.737,6.694-5.946,5.973h0a.8.8,0,0,1-.516.245.779.779,0,0,1-.52-.254L7.885,13.542a.177.177,0,0,1,0-.254l.792-.792a.172.172,0,0,1,.249,0L10.9,14.472l5.426-5.466a.176.176,0,0,1,.125-.053h0a.162.162,0,0,1,.125.053l.778.805A.175.175,0,0,1,17.362,10.069Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#5e469c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleChecked);
export default __webpack_public_path__ + "static/media/checkmark-circle-checked.a231a209c70b2d3649b2d20f9b340bbf.svg";
export { ForwardRef as ReactComponent };